import React from 'react'

type Props = {
  availSince?: number | null
  /** compact : version card/grille. full : version fiche produit avec date visible. */
  variant?: 'compact' | 'full'
  className?: string
}

/**
 * Badge "Précommande" reutilisable. Affiche la date estimee de livraison en mode full
 * si disponible. Les traductions viennent des cles i18n web_precommande_badge et
 * web_precommande_delivery_on (DB cscart_language_values, addon pms).
 */
const PrecommandeBadge: React.FC<Props> = ({ availSince, variant = 'compact', className = '' }) => {
  const hasDate = !!availSince && availSince > 0
  const formattedDate = hasDate
    ? new Date(availSince * 1000).toLocaleDateString('fr-FR')
    : null

  if (variant === 'compact') {
    return (
      <span
        className={`inline-block text-[10px] font-semibold uppercase tracking-wide text-white bg-amber-600 rounded-md px-2 py-0.5 whitespace-nowrap ${className}`}
      >
        {t({ id: 'web_precommande_badge' })}
      </span>
    )
  }

  return (
    <div className={`inline-flex flex-col gap-0.5 ${className}`}>
      <span className="text-xs font-semibold uppercase tracking-wide text-white bg-amber-600 rounded-md px-2 py-1 whitespace-nowrap w-fit">
        {t({ id: 'web_precommande_badge' })}
      </span>
      {hasDate && formattedDate && (
        <span className="text-xs text-amber-700 italic">
          {t({ id: 'web_precommande_delivery_on' }).replace('{date}', formattedDate)}
        </span>
      )}
    </div>
  )
}

export default PrecommandeBadge
